import React, { Fragment } from 'react';
import { withAreaGetter } from 'providers/AreasConsumers';

import GenericFilterParamListBrowser from './GenericFilterParamListBrowser';
import HeaderPortal from '../../../../components/layout/HeaderPortal';
import { ADMIN_GENERIC_FILTER_PARAMS_READ } from 'constants/rightsCodes';
import PermissionCheck from 'components/common/PermissionCheck';

const Route = () => {
  return (
    <Fragment>
      <HeaderPortal />
      <PermissionCheck authorizationCode={ADMIN_GENERIC_FILTER_PARAMS_READ}>
        <GenericFilterParamListBrowser />
      </PermissionCheck>
    </Fragment>
  );
};

export default withAreaGetter(Route);
